/**
 * @generated SignedSource<<1bc3c782f03071cc449731df3488cc88>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarSoldItems_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsColumn_user">;
  readonly " $fragmentType": "PdpRespSimilarSoldItems_user";
};
export type PdpRespSimilarSoldItems_user$key = {
  readonly " $data"?: PdpRespSimilarSoldItems_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarSoldItems_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarSoldItems_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSimilarSoldItemsColumn_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a0cadef34282250e003d5adf62b9036b";

export default node;
